import React, { useEffect, useState } from 'react';
import './styles.scss';
import Header from '../../components/Header';
import Menu from '../../components/Menu';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';

interface Icollapse {
  title: string;
  content: string;
  open: boolean;
}

const collapseItens: Icollapse[] = [
  {
    title: 'Como podemos explicar melhor a doença venosa crônica?',
    content: `A doença venosa crônica desenvolve-se devido ao baixo retorno
  do sangue venoso ao coração, o que se manifesta em sintomas
  (dor, sensação de pernas pesadas, sensação de inchaço e
  cãibras noturnas) e sinais (telangiectasias, veias varicosas,
  edema, alterações tróficas e úlcera venosa). Alguns factores
  de risco estão associados à doença venosa crónica, como
  excesso ou ganho de peso, sexo feminino, periodos prolongados
  em pé, inatividade física, alguns desportos (por exemplo,
  tenis, rugby) e a exposição ao calor.`,
    open: true,
  },
  {
    title:
      'A idade das suas veias é maior que a sua idade real? O que isso significa?',
    content: `teste conteudo`,
    open: false,
  },
  {
    title: 'Alguns conselhos para prevenir a insuficiência venosa crônica.',
    content: `teste conteudo.`,
    open: false,
  },
  {
    title: 'Para mais informações.',
    content: `teste conteudo.`,
    open: false,
  },
];

const Risk: React.FC = () => {
  const [collapse, setCollapse] = useState<Icollapse[]>([]);

  useEffect(() => {
    setCollapse(collapseItens);
  }, []);

  return (
    <>
      <Header />
      <div className="container risks">
        <Menu />
        <div className="content main">
          <h1>Compreender melhor o risco venoso</h1>
          <div className="collapse">
            {collapse.length > 0 &&
              collapse.map((item: Icollapse, key: number) => (
                <div className={item.open ? `item open` : `item`} key={key}>
                  <div
                    className="title"
                    onClick={() => {
                      const findItem = collapse.findIndex(
                        (index) => index.title === item.title
                      );
                      let newArray = [...collapse];
                      newArray[findItem] = {
                        ...newArray[findItem],
                        open: !newArray[findItem].open,
                      };
                      setCollapse(newArray);
                    }}
                  >
                    {item.title}
                    {item.open ? (
                      <AiOutlineMinus size={24} color="#fff" />
                    ) : (
                      <AiOutlinePlus size={24} color="#fff" />
                    )}
                  </div>
                  <div className="info">
                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Risk;
